import { Injectable } from '@angular/core';
import { GLOBAL } from './global';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpClientModule } from '@angular/common/http';
import { Router, ActivatedRoute, Params } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class UpaegService {
  public url: string;
  public identity;
  public token;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    public _http: HttpClient
  ) {
    this.url = GLOBAL.url;
   }

   getToken() {
    let token = localStorage.getItem('token');
    if (token !== 'undefined') {
        this.token = token;
    } else {
        this.token = null;
    }
    return this.token;
  }

  getMyUpaegs(): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.get(this.url + 'get/my/upaegs', { headers });
  }

  devinculateUpaeg(params): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.post(this.url + 'devinculate/upaeg', params, { headers });
  }

  buscarUpaeg(curp): Observable<any> {
    curp = curp.toUpperCase();
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.get(this.url + 'get/upaeg/' + curp, { headers });
  }

  vinculateUpaeg(params): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.post(this.url + 'vinculate/upaeg', params, { headers });
  }

  saveUpaeg(params): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.post(this.url + 'save/upaeg/fisica/V2', params, { headers });
  }

  getUpaegFisica(idUpaeg): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.get(this.url + 'get/upaeg/fisica/' + idUpaeg, { headers });
  }

  saveUpaegMoral(params): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.post(this.url + 'save/upaeg/moral/V2', params, { headers });
  }

  getUpaegMoral(idUpaeg): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.get(this.url + 'get/upaeg/moral/' + idUpaeg, { headers });
  }

  saveUpaegGrupal(params): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.post(this.url + 'save/upaeg/grupal/V2', params, { headers });
  }


  getGralesUpaeg(idUpaeg): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.get(this.url + 'get/upaeg/grales/' + idUpaeg, { headers });
  }



}
